import { Box, Skeleton } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import BaseCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/BaseCell'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { RestDay } from 'modules/shift_management/lib/types'
import type Leave from 'modules/shift_management/store/internal/models/Leave'

export interface TimeOffCellProps {
  date: moment.Moment
  leaves: Leave[] | undefined
  restDays: RestDay[] | undefined
  loading: boolean
  onClick: () => void
}

const TimeOffCell = ({ date, leaves, restDays, loading, onClick }: TimeOffCellProps) => {
  const [{ view }] = useSchedule()

  const leavesLength: number = leaves?.length || 0
  const publishedRestDays = restDays ? restDays.filter((restDay) => restDay.isPublished) : []
  const publishedRestDaysLength = publishedRestDays.length
  const emptyCell = !leavesLength && !publishedRestDaysLength

  const leavesByDateCopy = i18n.tp('shift_management.time_off_row.absences', {
    count: leavesLength,
  })

  const restDaysByDateCopy = i18n.tp('shift_management.time_off_row.rest_days', {
    count: publishedRestDaysLength,
  })

  const handleClick = () => {
    if (emptyCell) return

    const trackingProperties = {
      view: view.viewType,
      view_type_by: view.groupType,
      day_of_button: date.format('dddd'),
    }

    track(trackingEvents.shiftManagement.goToShiftManagementAbsencesDetails, trackingProperties)
    onClick()
  }

  return (
    <>
      <Box
        cursor={!emptyCell ? 'pointer' : 'default'}
        flexDirection="column"
        flexGrow
        gap="s4"
        padding="s4"
        paddingBottom="s8"
        onClick={handleClick}
      >
        {loading && <Skeleton height="s24" />}
        {!loading && !!leavesLength && (
          <BaseCell
            background="champagne200"
            minHeight="s24"
            maxHeight="s24"
            alignItems="center"
            justifyContent="center"
            flexGrow={false}
          >
            {leavesByDateCopy}
          </BaseCell>
        )}

        {!loading && !!publishedRestDaysLength && (
          <BaseCell
            background="fuchsia200"
            minHeight="s24"
            maxHeight="s24"
            alignItems="center"
            justifyContent="center"
            flexGrow={false}
          >
            {restDaysByDateCopy}
          </BaseCell>
        )}
      </Box>
    </>
  )
}

export default observer(TimeOffCell)
